import {defineAsyncComponent} from 'vue';

export const HitIcon = defineAsyncComponent(() => import('./HitIcon.vue'));
export const HitProgressbar = defineAsyncComponent(
  () => import('./HitProgressbar.vue'),
);
export const HitSpinner = defineAsyncComponent(
  () => import('./HitSpinner.vue'),
);
